import React from 'react'

type Props = {
    form?       : any
    size?       : 'size-30-70'
    className?  : string
    children?   : any
}

export default function Form(props:Props) {
    return (
        <div className={Classes("ui5-form",props.size, props.className)}>
            {props.children}
        </div>
    )
}